package com.nonopn.skywatcher.common.app.pages.map.view.views

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.pages.map.view.alerts.dividerColor


@Composable
fun CustomVerticalDivider(
    height: Dp = 90.dp
) {
    Column(
        Modifier.width(1.dp).height(height)
            .clip(
                RoundedCornerShape(
                    topStart = 2.dp,
                    topEnd = 2.dp,
                    bottomStart = 2.dp,
                    bottomEnd = 2.dp
                )
            ),
    ) {
        Column(Modifier.background(dividerColor()).fillMaxSize()) {
            // nothing
        }
    }
}